<template>
	<v-row class='fill-height' no-gutters>
		<v-col cols='4'>
			<v-row no-gutters>
				<v-col cols='12'>
					<v-card class='fill-height d-flex justify-center align-center mx-3 rounded-md'>
						<span class='font-weight-bold text-uppercase text-center indigo--text text--darken-4 text-h3'>Quick money</span>
					</v-card>
				</v-col>
				<v-col cols='12' class='py-1 text-center'>
					<v-card color='#1A237E' class='text-center py mx-6 rounded-md'>
						<span class='font-weight-bold text-uppercase text-center text-h5 white--text'>Lottery Results</span>
					</v-card>
					<font-awesome-icon class='white--text' icon='caret-down' size='2x' />
				</v-col>
				<v-col cols='12'>
					<v-card rounded='xl'>
						<lottery-result-auto-display
							:general-information='generalInformation'
							:entries-per-page='lotteryEntriesPerPage'
							:time-to-show-each-page='timeToShowEachLotteryResultPage'>
							<template #page='{ entries }'>
								<v-container class='px-0 py-0'>
									<lottery-result v-for='(entry, index) in entries'
																	class='lottery-result'
																	:class="{'rounded-b-xl': index === entries.length - 1}"
																	:key='entry.name'
																	:lottery='entry' />
								</v-container>
							</template>
						</lottery-result-auto-display>
					</v-card>
				</v-col>
				<v-col cols='12' class='justify-center'>
					<v-img contain height='115' :src="require('@/assets/img/quickmoney/logo.png')" />
				</v-col>
			</v-row>
		</v-col>
		<v-col cols='3' class='px-4'>
			<v-row no-gutters>
				<v-col>
					<v-card class='fill-height rounded-xl indigo--text text--darken-4'>
						<countdown px-5 py-5 text-center :sortition='generalInformation.sortition' />
					</v-card>
				</v-col>
			</v-row>
			<v-row no-gutters class='py-2'>
				<v-col>
					<v-card color='#1A237E' class='fill-height d-flex justify-center align-center mx-8 rounded-lg'>
						<span class='font-weight-bold text-uppercase text-center text-h5 white--text'>Last Winning</span>
					</v-card>
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col>
					<v-card class='text-center fill-height rounded-xl'>
						<result-display v-if='generalInformation.results[0]' :result='generalInformation.results[0]' />
					</v-card>
				</v-col>
			</v-row>
			<v-row no-gutters class='py-1 text-center'>
				<v-col>
					<span class='font-weight-bold text-uppercase white--text text-h6'>Draw every 30 minutes</span>
				</v-col>
			</v-row>
		</v-col>
		<v-col cols='5'>
			<v-row no-gutters>
				<v-col>
					<current-date-and-time-display class="white--text" :general-information='generalInformation' />
				</v-col>
			</v-row>
			<card-presenter
				:time-per-page='[timeToShowResultsPage, timeToShowPrizesPage]'>
				<template #page-1>
					<v-row no-gutters>
						<v-col cols='12' class='py-2'>
							<v-card color='#1A237E' class='fill-height d-flex justify-center align-center mx-5 rounded-lg'>
								<span class='font-weight-bold text-uppercase text-center text-h4 white--text'>Winning Numbers</span>
							</v-card>
						</v-col>
						<v-col cols='12'>
							<v-card class='rounded-xl text-uppercase y-1'>
								<results-table class='indigo--text text--darken-4 text-center'
															 :header-props="{ class: 'grey rounded-t-xl font-weight-bold py-3' }"
															 :limit="10"
															 :results='generalInformation.results' />
							</v-card>
						</v-col>
					</v-row>
				</template>
				<template #page-2>
					<v-row no-gutters justify='center'>
						<v-col cols='12' class='py-3'>
							<v-card color='#1A237E' class='fill-height d-flex justify-center align-center mx-5 rounded-lg'>
								<span class='font-weight-bold text-uppercase text-center text-h4 white--text'>Fast payments</span>
							</v-card>
						</v-col>
						<v-col cols='7'>
							<v-card class='rounded-xl'>
								<prizes-list class='font-weight-bold' :general-information='generalInformation' />
							</v-card>
						</v-col>
					</v-row>
				</template>
			</card-presenter>
		</v-col>
	</v-row>
</template>

<script>
import ResultDisplay from '@homepage/components/ResultDisplay.vue';
import Countdown from '@homepage/components/Countdown.vue';
import ResultsTable from '@homepage/components/ResultsTable.vue';
import CurrentDateAndTimeDisplay from '@homepage/components/CurrentDateAndTimeDisplay.vue';
import { generateImageMapFor } from '@homepage/helpers/image.js';
import LotteryResultAutoDisplay from '@homepage/components/LotteryResultAutoDisplay.vue';
import LotteryResult from '@homepage/components/LotteryResult.vue';
import CardPresenter from '@homepage/components/CardPresenter.vue';
import PrizesList from '@homepage/components/PrizesList.vue';

export default {
	name: 'QuickMoneyBoard',
	provide() {
		return {
			imagesMap: generateImageMapFor('quickmoney'),
			generalInformation: this.generalInformation
		};
	},
	props: {
		generalInformation: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			timeToShowResultsPage: 15000,
			timeToShowPrizesPage: 8000,
			timeToShowEachLotteryResultPage: 10000,
			lotteryEntriesPerPage: 3
		};
	},
	components: {
		PrizesList,
		LotteryResult,
		LotteryResultAutoDisplay,
		CurrentDateAndTimeDisplay,
		ResultDisplay,
		Countdown,
		ResultsTable,
		CardPresenter
	},
	beforeCreate() {
		this.$emit('change-style', { backgroundImage: require('@/assets/img/quickmoney/background.webp') });
	}
};
</script>

<style>
.lottery-result:nth-child(even) {
	background-color: #eaeaea;
}
.prize-item:nth-child(odd) {
	background-color: #5563a54f;
}

.prize-name {
	color: #1a237e;
	font-weight: 800;
	font-size: 160%;
}

.amount {
	color: #1a237e;
	font-weight: 800;
	font-size: 230%;
}
</style>
